import React from 'react';
import { Pages, UiStore } from '@gamiphy/loyalty-station-desktop/store/ui';

export const useShowLevel = (mobile: boolean): boolean => React.useMemo(() => (
  !(mobile && UiStore.currentPage === Pages.redeem)
), [
  UiStore.currentPage,
  mobile,
]);

export const useShowProgress = (mobile: boolean): boolean => React.useMemo(() => (
  !(mobile && UiStore.currentPage === Pages.redeem)
), [
  UiStore.currentPage,
  mobile,
]);
